import { Component, h, Prop, Host } from '@stencil/core';

import { setCustomerOrdersListener, setCustomerListeners, stopCustomerListeners } from '../../store/customer.store';
import { settings, setBusinessSettingsListener, stopBusinessSettingsListener } from '../../store/settings.store';
import { selection, onSelectionChange } from '../../store/selection.store';
import { schedule, setDateScheduleListener, setAvailableDatesListener, stopScheduleListeners } from '../../store/schedule.store';
import { discountState, setDiscountsListener, stopDiscountListener } from '../../store/discounts.store';
import { startVersionListener, stopVersionListener } from '../../store/version.store';

import { FirebaseService } from '../../utils/firebase';
import { addStyleSettings } from '../../utils/custom-style';


@Component({
  tag: 'tambr-widget',
  styleUrl: 'tambr-widget.css',
  shadow: true
})
export class TambrWidget {

  @Prop() businessId: string;
  @Prop() spaceId?: string;
  @Prop() categoryId?: string;
  @Prop() locationId?: string;
  @Prop() demo?: string | false = false;

  async componentWillLoad() {
    settings.businessId = this.businessId;
    settings.spaceId = this.spaceId;
    settings.categoryId = this.categoryId;
    settings.locationId = this.locationId;
    settings.demo = this.demo;
    settings.pageBodyOverflow = document.body.style.overflow;

    FirebaseService.initApp();

    startVersionListener();

    onSelectionChange( 'date', date => {
      setDateScheduleListener( date );
      setCustomerOrdersListener();
    });

    setAvailableDatesListener();
    setCustomerListeners();
    setBusinessSettingsListener();
    setDiscountsListener();
  }

  async disconnectedCallback() {
    stopCustomerListeners();
    stopBusinessSettingsListener();
    stopScheduleListeners()
    stopDiscountListener();
    stopVersionListener();
    await FirebaseService.deleteApp();
  }

  isInitialLoading() { 
    return !settings.appCheckFailed && (
      ( !schedule.availableDatesLoaded && schedule.availableDatesLoading ) ||
      ( !schedule.dateScheduleLoaded && schedule.dateScheduleLoading ) ||
      ( !settings.businessSettingsLoaded && settings.businessSettingsLoading ) ||
      ( !discountState.loaded && discountState.loading )
    );
  }


  render() {    
    if ( this.isInitialLoading() ) {
      return ( <div class='initial-loading'><tambr-loading-spinner /></div> );
    }
    
    return (
      <Host style={ addStyleSettings() }>

        <div id='dates-wrapper'>
          <tambr-calendar-dates />
          <div class={ 'progress ' + ( schedule.dateScheduleLoading && !settings.appCheckFailed ? 'loading' : '') }>
            <div class='indeterminate'></div>
          </div>
        </div>

        { this.renderCalendar() }

        <div class='footer'>
          <a target='_blank' href='http://tambr.app'>
            <tambr-icon type='logo' class='logo-icon' />tambr.app
          </a>
        </div> 
         
      </Host>
    );
  }


  renderCalendar() {
    if ( settings.appCheckFailed || !selection.date ) {
      return ( 
        <div class='unavailable-message not-available'>
          <p>Schedule is unavailable.</p>
        </div>
      );
    }

    if ( schedule.dateSchedule ) {
      if ( !schedule.dateSchedule.available ) {

        return ( 
          <div class='unavailable-message not-available'>
            <p>There is no availability for the selected date</p>
          </div>
        );

      } else {
        return ( <tambr-calendar /> );
      }
    }
  }

}